var fontWeight;

(function (fontWeight) {
  fontWeight["normal"] = "normal";
  fontWeight["medium"] = "500";
  fontWeight["bold"] = "bold";
  fontWeight["heavy"] = "900";
})(fontWeight || (fontWeight = {}));

export default fontWeight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/fontWeight/index.js
// module id = 728
// module chunks = 12